// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__plp8m","loading_section":"style_loading_section__aAXT7","loader":"style_loader__AkY9k","boxes":"style_boxes__-3vC1"};